export default __webpack_public_path__ + "static/media/05en.0be2eb37.mp3";